import { observer } from "mobx-react";

import Icon from "components/UI/IconSVG/Icon";
import { BudgetSlider } from "components/BudgetSlider/BudgetSlider";
import Equipment from "../../Equipment/Equipment";
import Faqed from "components/UI/Faqed/Faqed";
import CheckBox from "components/UI/CheckBox/CheckBox";

import { SERVER_PRICE } from 'markets/YandexSeo';

import "./BotsCalculator.scss";

const BotsCalculator = observer(({ store, modeBots, currentCalculatorPrice, isTestPackageSelected }) => {
  const testing = store.testing;

  const totalSum = isTestPackageSelected
    ? currentCalculatorPrice
    : (currentCalculatorPrice + (store.isBotFarm ? SERVER_PRICE : 0));

  return (
    <div className="bots-calculator">
      <div className="bots-calculator__container">
        <div className="bots-calculator__container-top">
          <div className="bots-calculator__info">
            <p className="bots-calculator__info-text">Стоимость ботов</p>
            <p className="bots-calculator__info-sum">{testing ? 'ТЕСТ' : `${currentCalculatorPrice.toLocaleString()} ₽`}</p>
          </div>

          {!isTestPackageSelected && store.isBotFarm &&
            <p className="bots-calculator__price-equipment">
              + аренда оборудования <span>{SERVER_PRICE.toLocaleString() + '\u00a0₽'}</span>
            </p>
          }
        </div>

        <div className="bots-calculator__budget" style={testing ? { visibility: 'hidden' } : {}}>
          <BudgetSlider store={store} modeBots={modeBots} disabled={testing}>
            <Icon className="bots-calculator__budget-icon" sprite="another" name="bot-budget" />
            <p>{testing ? '' : `≈ ${store.currentCalculator.chainsCount.toLocaleString()}`}</p>
          </BudgetSlider>
        </div>
      </div>

      <div className="bots-calculator__checked">
        <Faqed text="Система, которая автоматически создает и управляет ботами, адаптированными под ваши интересы. Боты могут собирать информацию, публиковать контент, взаимодействовать с подписчиками и выполнять другие задачи, экономя ваше время">
          <CheckBox title="Персонализация с учетом краткосрочных и долгосрочных интересов по Метрике" checked={store.isBotFarm} onClick={() => store.setIsBotFarm(!store.isBotFarm)} />
        </Faqed>
      </div>

      <div className="bots-calculator__container">
        {store.isBotFarm && !isTestPackageSelected && <Equipment />}
        <div className="bots-calculator__price-total">
          <p>Итого:</p>
          <p>{testing ? 'ТЕСТ' : `${totalSum.toLocaleString()} ₽`}</p>
        </div>
      </div>
    </div>
  );
});

export default BotsCalculator;
